{
	"type": "circle",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"circle-radius": 4.8,
		"circle-stroke-width": 0.8,
		"circle-stroke-color": "#444",
		"circle-stroke-opacity": 0.6,
		"circle-color": [
			"case",
			["==", ["get", "speed85"], null],
			"#a2a2a2",
			[
				"step",
				["get", "speed85"],
				"#f5f500",
				36,
				"#f5b800",
				44.5,
				"#f57a00",
				48,
				"#f53d00",
				51.5,
				"#f50000"
			]
		]
	}
}
